import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';

// Interface for the server's AdminResponse wrapper
interface AdminResponse<T> {
  success: boolean;
  message: string;
  data: T;
  meta?: any;
}

export interface VersionInfo {
  version: string;
  environment: string;
  build_date: string;
}

@Injectable({
  providedIn: 'root'
})
export class VersionService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }

  /**
   * Get version information from the server
   */
  getServerVersion(): Observable<VersionInfo> {
    return this.http.get<AdminResponse<VersionInfo>>(`${this.apiUrl}/api/version`)
      .pipe(
        map(response => {
          if (response.success && response.data) {
            return response.data;
          } else {
            throw new Error(response.message || 'Failed to get server version');
          }
        })
      );
  }

  /**
   * Get client version information
   */
  getClientVersion(): VersionInfo {
    return {
      version: environment.version,
      environment: environment.name,
      build_date: environment.buildDate || new Date().toISOString()
    };
  }
}
